import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useI18n } from '../lib/i18n';
import { LangSwitch } from '../components/LangSwitch';

export function LoginPage() {
  const { user, login } = useAuth();
  const { t, apiMessage } = useI18n();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<ApiError | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/" replace />;

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(phone, password);
    } catch (err) {
      setError(err instanceof ApiError ? err : null);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-screen">
      <form className="card auth-card" onSubmit={handleSubmit} noValidate>
        <div className="auth-card__head">
          <div>
            <img className="auth-card__logo" src="/logo.png" alt="ASKO" />
            <h1 className="auth-card__title">{t('app.product')}</h1>
            <p className="auth-card__subtitle">{t('login.subtitle')}</p>
          </div>
          <LangSwitch />
        </div>

        <label className="field">
          <span className="field__label">{t('login.phone')}</span>
          <input
            className="field__input"
            type="tel"
            inputMode="numeric"
            placeholder="998901234567"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            autoComplete="username"
            required
          />
          {error?.fieldError('phone') && (
            <span className="field__error">{error.fieldError('phone')}</span>
          )}
        </label>

        <label className="field">
          <span className="field__label">{t('login.password')}</span>
          <input
            className="field__input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          {error?.fieldError('password') && (
            <span className="field__error">{error.fieldError('password')}</span>
          )}
        </label>

        {error && !error.details && (
          <div className="alert alert--error" role="alert">
            {apiMessage(error)}
          </div>
        )}

        <button className="btn btn--primary" type="submit" disabled={submitting}>
          {submitting ? t('login.submitting') : t('login.submit')}
        </button>
      </form>
    </div>
  );
}
